// V2 页面骨架（chrome）：kicker 左上 / 页码右上 / foot 底部
// 对应后端 _shared/pptx/v2/chrome.ts（坐标保持一致）

import { SPACING } from "../../lib/tokens.generated";
import { px, pt, type V2Skin } from "./shared";
import { isTerm, isReport, memphisTheme, memphisPalette } from "./themes";

export default function V2Chrome({ skin, kicker, page, total, foot }: {
  skin: V2Skin; kicker: string; page: number; total: number; foot: string;
}) {
  const m = SPACING.marginX;
  const W = 13.333;
  // term（043 §4.4）：kicker 前缀 `>` 终端提示符，磷光绿——终端腔签名之一
  const term = isTerm(skin);
  // report（043 §4.5）：全大写 kicker 压 hairline（FT 式页眉）+ 底部 SOURCES 来源行
  const report = isReport(skin);
  // memphis（043 §4.7）：kicker 下短色带（5 色轮用）
  const mp = memphisTheme(skin);
  return (
    <>
      <div style={{
        position: "absolute", left: px(m), top: px(SPACING.chromeTop), width: px(6), height: px(0.26),
        fontSize: pt(skin.scale.meta), color: term ? skin.accent : skin.sub, fontFamily: skin.fontMono,
        letterSpacing: "0.15em", textTransform: "uppercase",
      }}>{(term ? "> " : "") + kicker}</div>
      {/* report：kicker 下方全宽 hairline（chrome.ts 分支） */}
      {report && (
        <div style={{
          position: "absolute", left: px(m), top: px(SPACING.chromeTop + 0.24),
          width: px(W - 2 * m), height: 1,
          background: skin.hairline,
        }} />
      )}
      {/* memphis：kicker 下短色带（轮用色；内容页奶油底上更醒目） */}
      {mp && (
        <div style={{
          position: "absolute", left: px(m), top: px(SPACING.chromeTop + 0.26),
          width: px(0.9), height: px(0.05),
          background: memphisPalette(mp)[(page - 1) % 5],
        }} />
      )}
      <div style={{
        position: "absolute", left: px(10.9), top: px(SPACING.chromeTop), width: px(1.77), height: px(0.26),
        fontSize: pt(skin.scale.meta), color: skin.sub, fontFamily: skin.fontMono,
        textAlign: "right", letterSpacing: "0.08em",
      }}>{String(page).padStart(2, "0")} / {total}</div>
      <div style={{
        position: "absolute", left: px(m), top: px(SPACING.chromeFootY - 0.06),
        width: px(W - 2 * m), height: 1, background: skin.hairline,
      }} />
      {/* report：foot 行即来源行（043 §4.5 source line） */}
      <div style={{
        position: "absolute", left: px(m), top: px(SPACING.chromeFootY), width: px(W - 2 * m), height: px(0.26),
        fontSize: pt(skin.scale.meta), color: skin.sub, fontFamily: skin.fontMono, letterSpacing: "0.08em",
      }}>{(term ? "$ " : report ? "SOURCES: " : "") + foot}</div>
    </>
  );
}
